import { createAction } from '@reduxjs/toolkit'
import { ModalState } from '@store/Modal/modalReducer'

export const showModal = createAction<ModalState>('@MODAL/SHOW_MODAL')
export const hideModal = createAction('@MODAL/HIDE')
